export const isPartConfirmationEligibleSupplier = (
  supplierId?: string,
  allowedIds?: string[],
): boolean => {
  const normalizedSupplierId = String(supplierId ?? "").trim().toLowerCase();
  if (!normalizedSupplierId || !allowedIds?.length) {
    return false;
  }
  return allowedIds.some(
    (id) => String(id).trim().toLowerCase() === normalizedSupplierId,
  );
};
